// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__2Uxj7","tag_indicators":"tag_tag_indicators__-GAC7","manually_tag":"tag_manually_tag__Wixs-","volcano":"tag_volcano__da2n-","gold":"tag_gold__e8GSX"};